import { StyledFlex, StyledMargin } from '@dreryk/react-components';

import { PatientPhoneNotificationActionBar } from './PatientPhoneNotificationActionBar';
import { PatientPhoneNotificationForm } from './PatientPhoneNotificationForm';
import { PatientPhoneNotificationPackageSection } from './PatientPhoneNotificationPackageSection';
import { PatientPhoneNotificationSummaryTable } from './PatientPhoneNotificationSummaryTable';

export const PatientPhoneNotificationPanel = (): JSX.Element => {
   return (
      <StyledMargin bottom={32} right={10}>
         <StyledFlex gap={'40px'} direction={'column'}>
            <PatientPhoneNotificationActionBar>
               <PatientPhoneNotificationForm />
            </PatientPhoneNotificationActionBar>
            <PatientPhoneNotificationPackageSection />
            <PatientPhoneNotificationSummaryTable />
         </StyledFlex>
      </StyledMargin>
   );
};
